import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login/login.service';

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss']
})
export class AdminHomeComponent implements OnInit {

  constructor(
    private _loginService: LoginService,
    private _router: Router,
  ) { }

  ngOnInit(): void {
  }

  goToRenewPassword(): void {
    const user = this._loginService.getCurrentUser();
    const email = user?.email ?? '';
    this._router.navigate(['/login/renew-password', email]);
  }
}
